import { render } from "./Recipe1View.vue?vue&type=template&id=69dc3b94&scoped=true"
import script from "./Recipe1View.vue?vue&type=script&lang=js"
export * from "./Recipe1View.vue?vue&type=script&lang=js"

import "./Recipe1View.vue?vue&type=style&index=0&id=69dc3b94&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69dc3b94"]])

export default __exports__